import { Component, OnInit } from '@angular/core';
import { Button1Component } from '../button1/button1.component';
import { Button2Component } from '../button2/button2.component';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { CommanService } from '../../_services/comman.service';
import { GalleriaModule } from 'primeng/galleria';
import { DialogModule } from 'primeng/dialog';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { MessageService } from 'primeng/api';
import { user_privilege } from '../../../_model/user_privilege';
import { DatasearchService } from '../../_services/datasearch.service';
@Component({
  selector: 'app-grid-view',
  standalone: true,
  imports: [
    CommonModule,
    Button1Component,
    Button2Component,
    GalleriaModule,
    DialogModule,
    PaginatorModule,
  ],
  templateUrl: './grid-view.component.html',
  styleUrl: './grid-view.component.scss',
})
export class GridViewComponent {
  currResultData: any[] = [];
  currResultTotal: number = 0;
  gridViewCardColumns: any[] = [
    {
      field: 'country',
      table: 'gapd_mongos',
    },
    {
      field: 'productPackageImage',
      table: 'gapd_mongos',
    },
    {
      field: 'gbrn',
      table: 'gapd_mongos',
    },
    {
      field: 'cbrnGapd',
      table: 'gapd_mongos',
    },
    {
      field: 'racIracHracFrac',
      table: 'gapd_mongos',
    },
    {
      field: 'casRn',
      table: 'basic_product_details_MONGO',
    },
    {
      field: 'iupac',
      table: 'basic_product_details_MONGO',
    },
    {
      field: 'formulation',
      table: 'gapd_mongos',
    },
    {
      field: 'indication',
      table: 'basic_product_details_MONGO',
    },
    {
      field: 'chemicalClass',
      table: 'basic_product_details_MONGO',
    },
    {
      field: 'company',
      table: 'gapd_mongos',
    },
    {
      field: 'tradeProprietaryNames',
      table: 'gapd_mongos',
    },
    {
      field: 'typeOfProduct',
      table: 'gapd_mongos',
    },
    {
      field: 'mechanismOfActionMoa',
      table: 'basic_product_details_MONGO',
    },
    {
      field: 'chemicalStructure',
      table: 'basic_product_details_MONGO',
    },
  ];

  currColumns: any[] = [];
  currReadMoreData: string[] = [];
  isShowReadMoreDetailDialog: boolean = false;
  privilege_json!: user_privilege;
  pageLimit: number = 0;
  constructor(
    private _commanService: CommanService,
    private router: Router,
    private _messageService: MessageService,
    private datasearch: DatasearchService
  ) { }

  ngOnInit(): void {
    // Get columns
    this._commanService.getColumns().subscribe((res) => {
      this.currColumns = res;
    });

    // Get result data
    this._commanService.getResultData().subscribe((res) => {
      this.currResultData = res;
    });

    // Get result total
    this._commanService.getResultTotal().subscribe((res) => {
      this.currResultTotal = +res;
    });
    this._commanService.currentPrivilege.subscribe((res: any) => {
      this.privilege_json = res ? (res.privilege_json || res) : {};
      // console.log("privaleges json in large screen ",this.privilege_json)
    });
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error: API response success is false', res);
          }
        },
        (error: any) => {
          console.log('Error fetching database page limit:', error);
        }
      );
  }

  getFieldDisplayName(fieldName: string) {
    const found = this.currColumns.find(
      (elem: any) => elem.field === fieldName //&& elem.isDisplay === 1
    );
    return found ? found.header : fieldName;
  }

  display: boolean = false;
  images: any[] = [];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  showImage(imageUrl: string) {
    this.images = [
      {
        itemImageSrc: imageUrl,
        alt: 'Image',
        title: 'Preview',
      },
    ];
    this.display = true;
  }

  openDetailPage(item: any) {
    // this._commanService.setCurrBreadCrumbValue({
    //   label: 'Detail',
    //   route: '/search/result/detail',
    // });
    this.router.navigate(['platform/gapd-database/detail'], {
      state: item,
    });
    // console.log("itemmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm",item)
  }

  getGbrnProductString(item: any, fieldName: string): string {
    const joined = item.gbrn_products
      .map((obj: any) => obj[fieldName])
      .join(', ');
    return joined.length <= 290 ? joined : joined.slice(0, 290) + '...';
  }

  getGbrnProductLength(item: any, fieldName: string): number {
    const joined = item.gbrn_products
      .map((obj: any) => obj[fieldName])
      .join(', ');
    return Number(joined.length);
  }

  showAllData(data: string) {
    // this.currReadMoreData = data;
    this.isShowReadMoreDetailDialog = true;
  }

  showAllGapdProductData(item: any, fieldName: string) {
    if (item?.gbrn_products?.length > 0) {
      this.currReadMoreData = item.gbrn_products
        .map((prod: any) => prod[fieldName])
        .filter((val: string | undefined) => val);
    } else {
      this.currReadMoreData = [];
    }

    this.isShowReadMoreDetailDialog = true;
  }

  showAllGapdTableData(item: any, fieldName: string) {
    if (item && item[fieldName]) {
      this.currReadMoreData = [item[fieldName]];
    } else {
      this.currReadMoreData = [];
    }

    this.isShowReadMoreDetailDialog = true;
  }

  first: number = 0;
  pageNumber: number = 1;
  rows: number = 15;
  pageLimitInDatabaseLimit: number = 0;

  onPageChange(event: PaginatorState) {
    const nextPage = event.page !== undefined ? event.page + 1 : 1;

    // 🚨 Prevent going beyond Database Limit
    if (nextPage > this.pageLimitInDatabaseLimit) {
      this._messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: `You can only navigate up to page ${this.pageLimitInDatabaseLimit}.`,
      });
      return;
    }

    this.first = event.first ?? 0;
    this.pageNumber = nextPage;
    this.rows = event.rows ?? 15;

    this._commanService.setPageNumber(this.pageNumber);
    this._commanService.setLimit(this.rows);

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);

    console.log('✅ Page Change Applied:', {
      page: this.pageNumber,
      rows: this.rows,
      dbLimit: this.pageLimitInDatabaseLimit,
    });
  }

  isShowField(fieldName: string) {
    let matchedFieldObj = this.currColumns.find((columnObj: any) => {
      return columnObj.field === fieldName;
    });

    if (matchedFieldObj) {
      return true;
    } else {
      return false;
    }
  }
  copyToClipboard(value: string): void {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        this._messageService.add({
          severity: 'success',
          summary: 'Copied',
          detail: 'Copy To Clipboard',
        });
      })
      .catch((err) => {
        this._messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'There was an error copying the text.',
        });
      });
  }

  getAllGapdProductData(item: any, fieldName: string) {
    if (item?.gbrn_products?.length > 0) {
      this.currReadMoreData = item.gbrn_products
        .map((prod: any) => prod[fieldName])
        .filter((val: string | undefined) => val);

      const result = this.currReadMoreData.join('\n');
      return result;
    } else {
      return '';
    }
  }
  getDocumentLinks(documents: string): string[] {
    if (!documents) return [];
    return documents
      .split(/[\n;]+/)
      .map((link) => link.trim())
      .filter((link) => link.length > 0);
  }

  // ngOnDestroy(): void {
  //   this._commanService.removeLastBreadCrumbValue();
  // }
}
